import React from 'react'
import Modal from './MyModal'
import MyButton from './buttons'
import { IoIosWarning, IoIosCheckmarkCircle } from 'react-icons/io'
import { useTranslation } from 'react-i18next'

interface SubmitResultModalProps {
  isOpen: boolean
  onClose: () => void
  isSuccess: boolean
  message: string
}

const SubmitResultModal: React.FC<SubmitResultModalProps> = ({
  isOpen,
  onClose,
  isSuccess,
  message,
}) => {
  const { t } = useTranslation()
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className='bg-white rounded-lg overflow-hidden'>
        <div
          className={`p-4 ${isSuccess ? 'bg-anthracite' : 'bg-anthracite '}`}
        >
          <div className='flex items-center justify-center'>
            {isSuccess ? (
              <IoIosCheckmarkCircle className='text-3xl text-green-600' />
            ) : (
              <IoIosWarning className='text-3xl text-redpink' />
            )}
            <h2 className='ml-2 text-lg font-semibold text-white'>
              {isSuccess ? t('success') : t('error')}
            </h2>
          </div>
        </div>

        <div className='p-4'>
          <p className='text-center text-gray-600 mb-4'>{message}</p>

          <div className='flex justify-center'>
            <MyButton
              onClick={onClose}
              variant='redpink'
              className='w-full sm:w-auto'
            >
              {t('close')}
            </MyButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default SubmitResultModal
